module.exports = __webpack_public_path__ + "img/icon-sb-white-glove-delivery-icon-160x120-v1.408fffd.svg";